/* @flow */

import React, { Component } from 'react';
import { Modal, Button, Form } from 'semantic-ui-react';

type Props = {
  open: boolean,
  onSelected: (name: string, message?: string) => void,
  onClose: () => void,
};

type State = {
  name?: string,
  message?: string,
};

class AddGalleryModal extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  onNameChanged = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      this.setState({
        name: value,
      });
    }
  };

  onMessageChanged = (event: SyntheticEvent) => {
    this.setState({
      message: event.target.value,
    });
  };

  render() {
    const { name, message } = this.state;
    const { open, onSelected, onClose } = this.props;

    const confirm = () => {
      if (name) {
        onSelected(name, message);
      }
    };

    const canSubmit = name && name.length;

    return (
      <Modal closeIcon size="small" open={open} onClose={onClose}>
        <Modal.Header>Ajouter une gallerie</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Input
              error={(name && name.length === 0) || false}
              label="Nom"
              placeholder="Nom de la galerie"
              value={name || ''}
              onChange={this.onNameChanged}
            />
            <Form.TextArea
              label="Message"
              placeholder="Message de la gallerie"
              value={message || ''}
              onChange={this.onMessageChanged}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Annuler</Button>
          <Button
            disabled={!canSubmit}
            onClick={confirm}
            primary
            icon="plus"
            labelPosition="right"
            content="Ajouter"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AddGalleryModal;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/AddGalleryModal.js